import type { Error } from '@ps/web-shared-validators';
import React from 'react';

import type { FieldNameProp } from '@swf/core/types/Props';

import useAutoFocusInput from '../../hooks/useAutoFocusIf';
import { ADDRESS_MAX_LENGTH, useAddressFieldValidators } from '../../validators/address';
import TextInput from '../TextInput/TextInput';

import { TXTCLI_Street_Address } from './Address.messages.json';

interface Props extends FieldNameProp {
  country: string;
  requiredMessage?: Error['message'];
  value?: string;
  autofocus?: boolean;
}

const Address: React.FC<Props> = ({
  fieldName,
  value,
  autofocus = false,
  requiredMessage,
  country
}) => {
  const inputRef = useAutoFocusInput(autofocus);
  const validators = useAddressFieldValidators(country, requiredMessage);

  return (
    <TextInput
      id={fieldName}
      label={TXTCLI_Street_Address}
      maxLength={ADDRESS_MAX_LENGTH}
      autoComplete="off"
      value={value}
      validators={validators}
      checkDisabled
      inputRef={inputRef}
    />
  );
};

export default Address;
